import React__default from "react";
const HeaderInnerContext = React__default.createContext({
  openSection: null,
  setOpenSection: () => void 0,
  isSearchMinimized: false,
  containerRef: { current: null }
});
export {
  HeaderInnerContext
};
